<template>
    <div class="theme_colors">
    <button class="theme_btn" @click="themeChange">
      <img class="back" src="@/assets/theme/theme_btn.png" alt="">
      <img class="icon" :src="$store.state.themeArr[$store.state.themeIdx]" alt="">
    </button>
</div>
</template>

<script>
import css from '@/css/themeSwitch.css'
export default {
    methods:{
        themeChange(){
        this.$store.commit("switch")
      }
    },
    mounted(){
        this.$store.commit("getTheme")
    }
}
</script>

<style scoped>

</style>

